package one.healthium.pilates.ui.workouts

import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.meal_plans.domain.MealPlanInfoModel
import androidx.compose.runtime.Immutable

@Immutable
data class WorkoutsUiState(
    val loading: Boolean = false,
    val content: ContentScreenModel? = null,
    val shouldShowHKBanner: Boolean = false,
    val mealPlan: MealPlanInfoModel? = null,
    val isMetrics: Boolean = false,
)
